export default __webpack_public_path__ + "static/media/53.1150a750.png";